export default "__VITE_ASSET__BdBI7_Y___"